export default __webpack_public_path__ + "static/N0178-4f849452000ec32d80ac8a2856a09b31.png";